export const PAGEPUFF = "pagePuff";
export const LISTELEMENT = "listElement";
export const MAPBLOCK = "mapBlock";
export const CONCEPTS = "conceptContainer";
export const SERVICES = "serviceContainer";
export const COOKIEELEMENT = "cookieBlock";
export const QUOTATIONBLOCK = "quotationBlock";
export const QUOTATIONLISTBLOCK = "quotationListBlock";
export const PARALLAXBLOCK = "parrallaxElement";
export const EMPLOYEELISTBLOCK = "contactContainer";
export const FORMELEMENT = "formElement";
export const COLUMNELEMENT = "columnElement";
export const TWOCOLUMNBLOCK = "twoColumnBlock";
export const SLIDESHOW = "slideShow";
export const LINKLISTELEMENT = "linkList";
export const CONTACTFORM = "contactForm";
export const FAQBLOCK = "faqBlock";
export const INFOBLOCK = "infoBlock";
export const CTABLOCK = "ctaBlock";
export const SCRIPTBLOCK = "scriptBlock";
export const TEXTBLOCK = "textBlock";
export const VIDEOBLOCK = "videoblock";
export const STARTPAGEPUFFCONTAINER = "startPagePuffContainer";
export const MAILINGLISTBLOCK = "mailingListBlock";
export const IMAGEBLOCK = "imageBlock";
export const HOTELBOOKINGBLOCK = "hotelBookingBlock";
export const MEDIAITEM = "mediaItem";
export const TEXTITEM = "textItem";
export const COUNTINGNUMBERSBLOCK = "countingNumbersBlock";
export const ROUNDEDBLOCK = "roundedBlock";
export const SERVICEPACKAGESBLOCK = "servicePackagesBlock";
export const HTMLBLOCK = "htmlBlock";
export const IMAGELISTBLOCK = "imageListBlock";
